import { render, staticRenderFns } from "./DynamicFormFieldImagePicker.vue?vue&type=template&id=54c1482c&"
import script from "./DynamicFormFieldImagePicker.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldImagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports